const TEST_IDS = {
  tokenTextField: 'token-text-field',
  selectTokenField: 'select-token-field',
  availableAmount: 'available-amount',
};

export default TEST_IDS;
